import { assertNever } from '../lib/assert-never.js';

import type { ConsultType } from './exchange/exchange-types.js';

export type ConsultTab = 'group' | '1:1';

/**
 * Which scheduling tabs to show, from exchange `consultType` (token `consult-type` and/or FHIR-resolved task).
 * Only `flexible` or missing (`undefined`) → both tabs; `group` → group only; `1:1` / `ffs` → 1:1 only
 * (`ffs` uses the same tab; stage filters subsections).
 *
 * @remarks The return type is a NON-EMPTY tuple rather than `ConsultTab[]` so that
 * `getVisibleTabs(...)[0]` — the initial tab — stays a `ConsultTab` under `noUncheckedIndexedAccess`.
 *
 * The chain ends in {@link assertNever}, not in a trailing `return ['group', '1:1']`. That default
 * was dead for every declared input and was exactly what would let a FIFTH `ConsultType` compile
 * while silently offering the member both scheduling modes.
 */
export function getVisibleTabs(
  consultType: ConsultType | undefined,
): [ConsultTab, ...ConsultTab[]] {
  if (consultType === undefined || consultType === 'flexible') {
    return ['group', '1:1'];
  }
  if (consultType === '1:1' || consultType === 'ffs') return ['1:1'];
  if (consultType === 'group') return ['group'];
  return assertNever(consultType);
}
